import { useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import { Grid, IconButton, InputAdornment, Typography } from "@mui/material";

import pages from "../../../constants/pages";
import { TextField } from "../../../components";
import { colors } from "../../css components/Style";
import Image from "../../../assets/cashkaro_logo_v1.svg";
import { PrimaryLoadingButton } from "../../css components/Button";

export default function FormDisplay({ formikProps }) {
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);

  const uiDetails = useSelector((state) => state.renderUIDetails);

  return (
    <Grid container spacing={4} className="login-grid">
      <Grid size={12} textAlign={"center"}>
        <img style={{ height: "35px" }} src={Image} alt="logo" />
      </Grid>

      <Grid size={12}>
        <TextField
          required
          formikProps={formikProps}
          name="email"
          placeholder="Email address"
          label="Email address"
          autoComplete="off"
        />
      </Grid>

      <Grid size={12}>
        <TextField
          required
          label="Password"
          autoComplete="off"
          type={showPassword ? "text" : "password"}
          name="password"
          formikProps={formikProps}
          placeholder="Password"
          slotProps={{
            input: {
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    style={{ padding: 0 }}
                    onClick={() => setShowPassword(!showPassword)}
                  >
                    {!showPassword && <VisibilityOffIcon />}
                    {showPassword && <VisibilityIcon />}
                  </IconButton>
                </InputAdornment>
              ),
            },
          }}
        />
      </Grid>

      <Grid size={12} sx={{ margin: "5px 0" }} />

      <Grid size={12}>
        <PrimaryLoadingButton
          fullWidth={true}
          type="submit"
          variant="contained"
          onClick={formikProps.handleSubmit}
          disabled={!formikProps.dirty || !formikProps.isValid}
          loading={formikProps.isSubmitting}
        >
          Log In
        </PrimaryLoadingButton>
      </Grid>

      <Grid size={12} mt={"15px"} className="form-links">
        <Typography className="signup-link" variant="button">
          Don't have an account? &nbsp;
          <Typography
            variant="button"
            className="forgot-link"
            style={{ cursor: "pointer", color: colors.purple }}
            onClick={() => navigate("/sign-up")}
          >
            Create One
          </Typography>
        </Typography>

        <br />

        <Typography variant="button">
          <Typography
            className="forgot-link"
            variant="button"
            style={{ cursor: "pointer", color: colors.purple }}
            onClick={() => navigate(pages.resetEmailPasswordPage.route)}
          >
            Forgot Password?
          </Typography>
        </Typography>
      </Grid>
    </Grid>
  );
}
